import type { EditorView } from '@tiptap/pm/view';

/**
 * Reads an image File as a base64 data URL and inserts it as an Image node at the
 * current selection. `isEditorAlive` is checked inside the FileReader callback because
 * the async read may resolve after the editor view has been destroyed.
 */
export const insertImageFile = (view: EditorView, file: File, isEditorAlive: () => boolean): void => {
  const reader = new FileReader();
  reader.onload = () => {
    if (!isEditorAlive()) {
      return;
    }

    const dataUrl = reader.result;
    if (typeof dataUrl !== 'string') {
      return;
    }

    const node = view.state.schema.nodes.image?.create({ src: dataUrl });
    if (!node) {
      return;
    }

    view.dispatch(view.state.tr.replaceSelectionWith(node));
  };
  reader.readAsDataURL(file);
};
